import {active} from "./const.js";

document.getElementById('js-hamburger').addEventListener('click', function() {
  this.classList.toggle(active);
  if(this.classList.contains(active)) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'visible';
  }
  document.getElementById('js-offcanvas').classList.toggle(active);
});
